import * as React from 'react';

import { ProjectDiagramToolbar } from 'src/containers/ProjectDiagram/components/toolbar/ProjectDiagramToolbar';
import { ProjectDiagramView } from 'src/containers/ProjectDiagram/ProjectDiagramView';

export const ProjectDiagram: React.VFC = () => (
  <div className="sd-project-diagram">
    <ProjectDiagramToolbar />
    <ProjectDiagramView />
  </div>
);
